import React from 'react';
import './Gifting_step_4.css';

import MasterButton from '../../../general_components/MasterButton/MasterButton.js';
import Dropdown_w_category from '../../../general_components/Dropdown_w_category/Dropdown_w_category';
import MUI_Slider from '../../../general_components/material_ui/mui_Slider.js';
import gg_fees from '../../../../utils/gg_pricing.js';
import { calculateMonthlyProcessingFeeDollars } from '../../../../utils/monthly_gift_pricing.js';
import money from '../../../../utils/money.js';

import confetti_three from '../../../../images/illustrations/confetti_three.png'
import confetti_two from '../../../../images/illustrations/confetti_two.png'

class Gifting_step_4 extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            
            selected_fund_active: false,
            buttonActive: false,

            highlight_fields: false,
            custom_amount: false
        };

        this.handleDDSelection = this.handleDDSelection.bind(this);
        this.calculateFinalGift = this.calculateFinalGift.bind(this);
        this.calculateFees = this.calculateFees.bind(this);

        this.render_gift_media = this.render_gift_media.bind(this);

    }

    handleDDSelection(item, dd_name) {
        if (dd_name === 'payment_method') {
            // set the newly selected payment method
            this.setState(
                {   payment_method: item, 
                    buttonActive: true});
        }
    }

    /** Processing fee dollars; monthly adds 0.8% billing buffer on gift amount. */
    getProcessingFeeDollars(giftAmountCents, pmType, isMonthly) {
        if (isMonthly && pmType) {
            const giftDollars = giftAmountCents / 100;
            return calculateMonthlyProcessingFeeDollars(`$${giftDollars}`, pmType);
        }
        let fee;
        if (pmType === 'CC') {
            fee = (giftAmountCents * gg_fees.send_fees.cc_variable) + gg_fees.send_fees.cc_fixed;
        } else if (pmType === 'ACH') {
            fee = (giftAmountCents * gg_fees.send_fees.ach_variable) + gg_fees.send_fees.ach_fixed;
        } else {
            fee = 0;
        }
        return Math.floor(fee) / 100;
    }

    calculateFinalGift(){
        const isMonthly = !!this.props.isMonthlyGift;
        const pmType = this.props.selected_payment_method && this.props.selected_payment_method.type;
        if(this.props.accept_additional_charges) {
            return this.props.Gift_amount;
        } else {
            let amount = Number(this.props.Gift_amount.slice(1));
            let centAmount = amount * 100;
            const feeDollars = this.getProcessingFeeDollars(centAmount, pmType, isMonthly);
            const feeCents = Math.floor(feeDollars * 100);
            let new_centAmount = centAmount - feeCents;
            return '$' + String(new_centAmount / 100);
        }
    }

    calculateFees(){
            const isMonthly = !!this.props.isMonthlyGift;
            let amount = Number(this.props.Gift_amount.slice(1));
            let centAmount = amount * 100;
            const pmType = this.props.selected_payment_method && this.props.selected_payment_method.type;
            if (!pmType) {
                return '$0';
            }
            const feeDollars = this.getProcessingFeeDollars(centAmount, pmType, isMonthly);
            return '$' + String(feeDollars);
    }
    

    render_gift_media(){
        if(!typeof this.props.gift_media === 'string'){
            return null;
        } else {
            let split = this.props.gift_media.split(".");
            let extension = this.props.gift_media.split(".")[split.length - 1];
            if (extension === 'jpeg' || 
                extension === 'jpg' || 
                extension === 'png' ){
                    return (
                        <img 
                            src={this.props.gift_media} 
                            className={'greeting_image'}/>
                    )
            } else if ( 
                extension === 'quicktime' ||
                extension === 'mp4' ||
                extension === 'mov' ||
                extension === 'qt'){
                    return (
                        <video className='uploaded_media_preview' controls>
                            <source src={this.props.gift_media}/>
                        </video>
                    )
            }
        }
    }

    // render

    calculateTodayChargeTotal() {
        const giftPart = Number((this.calculateFinalGift() || '').slice(1)) || 0;
        const feePart = this.props.selected_payment_method ? Number((this.calculateFees() || '').slice(1)) || 0 : 0;
        const platformFee = Number(this.props.choose_fee_value) || 0;
        return giftPart + feePart + platformFee;
    }

    render () {
        const showAt = this.props.showAtStep != null ? this.props.showAtStep : 4;
        if (this.props.currentStep !== showAt) {
            return null;
        }

        const isMonthly = !!this.props.isMonthlyGift;
        const months = Number(this.props.gift_duration_months) || 0;
        const giftPerMonth = this.calculateFinalGift();

        return (
            <div>
                
                <h2>{'Payment & Confirmation'}</h2>
    
                <p style={{'marginBottom': '8px'}}>Payment</p>
                <Dropdown_w_category dd_name='payment_method'

                    header='Select Payment Method:' 
                    list={this.props.payment_methods}

                    handleItemClick={this.props.handleDDSelection}
                    handleLastItemClick={this.props.goToPayments}

                    selected={this.props.selected_payment_method}

                    lastItem={true}
                    last_item_add_button={true}
                    lastItemText='Add a payment method'
                    active={true}
                />

                
                <div className='headline_with_icon section_with_top_line'>
                    <p className=''>Choose Your GG Platform Fee</p>
                    <i onClick={this.props.toggle_gg_fee_help} className='material-icons-outlined inline_icon'>help</i>
                </div>


                
                <p className='small_text'>
                    Covers the cost of delivering {isMonthly ? 'each monthly gift' : 'this gift'} and enables us to improve Greatest Gift and reach more families.
                </p>

               
               
                {!this.state.custom_amount ? 
                <MUI_Slider
                    onChange={this.props.handleChooseFeeAmount}
                    value={Number(this.props.choose_fee_value)}
                    min={1}
                    max={15}
                    const marks = {[
                        {
                            value: 2,
                            label: (
                            <div className="slider-mark-container">
                                <div className="slider-mark-label">
                                <strong>$2</strong>
                                <div>Cover gift<br/>delivery</div>
                                </div>
                            </div>
                            ),
                        },
                        {
                            value: 5,
                            label: (
                            <div className="slider-mark-container">
                                <img src={confetti_two} alt="confetti" className="slider-mark-confetti" />
                                <div className="slider-mark-label">
                                <strong>$5</strong>
                                <div>Keep GG<br />running</div>
                                </div>
                            </div>
                            ),
                        },
                        {
                            value: 12,
                            label: (
                            <div className="slider-mark-container">
                                <img src={confetti_three} alt="confetti" className="slider-mark-confetti" />
                                <div className="slider-mark-label">
                                <strong>$12</strong>
                                <div>Build & improve<br />GG tools</div>
                                </div>
                            </div>
                            ),
                        },
                    ]}
                />
            :
            <div className="center_input_container">
                <div className="dollar_input_wrapper">
                    <span className="dollar_prefix">$</span>
                    <input
                        type="number"
                        id="custom_choose_fee_amount"
                        name="custom_choose_fee_amount"
                        min="0"
                        max="100"
                        step="1"
                        placeholder="0.00"
                        value={this.props.choose_fee_value}
                        className="custom_amount_input dollar_input"
                        onChange={e => {
                        const val = e.target.value;
                        const regex = /^\d{0,3}(\.\d{0,2})?$/;
                        if (val === '' || regex.test(val)) {
                            this.props.handleChooseFeeAmount(val);
                        }
                        console.log(val)
                        }}
                        onBlur={e => {
                        const val = e.target.value;
                        if (val === '' || val === null) {
                            this.props.handleChooseFeeAmount(0);
                        }
                        }}
                    />
                    </div>
                </div>

                }
                
                
                {(this.state.custom_amount && this.props.choose_fee_value === "0" ) ? 
                <p className='small_text '>Please only select $0 if you need to. A minimal $2 payment is required to cover the costs associated with delivering a gift.</p>
                
                :
                null
                }


                {!this.state.custom_amount ? 
                <p className='small_text underline align_center cursor' onClick={() => {this.setState({custom_amount: true})}}>Enter custom amount</p>
                :
                <p className='small_text underline align_center cursor' onClick={() => {this.setState({custom_amount: false})}}>Back</p>
                }
                


                <p className='two_column_line_new_section'>Confirm Gift Details:</p>
                <div className='two_column_text_container'>
                
                    <div className='two_column_line'>
                        <div className='left_column_text'><p className='small_text'>Send to:</p></div>
                        <div className='right_column_text'><p className='small_text'>{this.props.Send_to}</p></div>
                    </div>

                    <div className='two_column_line'>
                        <div className='left_column_text'><p className='small_text'>Gift for:</p></div>
                        <div className='right_column_text'><p className='small_text'>{this.props.Gift_for}</p></div>
                    </div>
                    
                    {this.props.selected_goals.length > 0 ? 
                    <div className='two_column_line'>
                        <div className='left_column_text'><p className='small_text'>Chosen goals:</p></div>
                        <div className='right_column_text'><p className='small_text'>{this.props.selected_goals.map(goal =>
                            goal
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize each word
                        )
                            .reduce((acc, curr, idx, arr) => {
                            if (idx === 0) return curr;
                            if (idx === arr.length - 1) return `${acc} and ${curr}`;
                            return `${acc}, ${curr}`;
                            }, '')}</p></div>
                    </div>
                    : null
                    }

                    <div className='two_column_line'>
                        <div className='left_column_text'><p className='small_text'>From:</p></div>
                        <div className='right_column_text'><p className='small_text'>{this.props.from}</p></div>
                    </div>

                    <div className='two_column_line'>
                        <div className='left_column_text'><p className='small_text'>Delivery date:</p></div>
                        <div className='right_column_text'><p className='small_text'>{this.props.schedule_delivery === 'now' ? 'Today' : this.props.Gift_delivery_shown_date}</p></div>
                    </div>

                    <div className='two_column_line'>
                        <div className='left_column_text'><p className='small_text'>Delivery time:</p></div>
                        <div className='right_column_text'><p className='small_text'>{this.props.schedule_delivery === 'now' ? 'Now' : `${this.props.Gift_delivery_shown_time.title} ${this.props.timezone.title}`}</p></div>
                    </div>

                    <div className='two_column_line two_column_line_new_section'>
                        <div className='left_column_text'><p className='small_text'>Gift amount{isMonthly ? ' (per month)' : ''}:</p></div>
                        <div className='right_column_text'><p className='small_text'>{isMonthly ? `${giftPerMonth}/mo` : giftPerMonth}</p></div>
                    </div>

                    {this.props.matching_available && (() => {
                        const giftStr = (this.props.Gift_amount || '').replace(/^\$/, '').replace(/,/g, '');
                        const giftCents = Math.round(parseFloat(giftStr) * 100) || 0;
                        const matchCents = giftCents > 0 ? Math.min(giftCents, this.props.matching_remaining_cents || 0) : 0;
                        if (matchCents <= 0) return null;
                        const matchDollars = matchCents / 100;
                        // Gift impact = amount receiver actually gets + matching boost (so it updates when user toggles covering fees)
                        const receiverGiftStr = (this.calculateFinalGift() || '').replace(/^\$/, '').replace(/,/g, '');
                        const receiverGiftCents = Math.round(parseFloat(receiverGiftStr) * 100) || 0;
                        const impactCents = receiverGiftCents + matchCents;
                        const impactDollars = impactCents / 100;
                        return (
                            <>
                                <div className='two_column_line'>
                                    <div className='left_column_text'><p className='small_text'>2x matching boost:</p></div>
                                    <div className='right_column_text'><p className='small_text'>+${money.addCommas(matchDollars)}</p></div>
                                </div>
                                <div className='two_column_line'>
                                    <div className='left_column_text'><p className='small_text'>Gift impact:</p></div>
                                    <div className='right_column_text'><p className='small_text confirm_gift_impact'>${money.addCommas(impactDollars)}</p></div>
                                </div>
                            </>
                        );
                    })()}

                    <div className={`two_column_line${this.props.matching_available ? ' two_column_line_new_section' : ''}`}>
                        <div className='left_column_text'><p className='small_text'>Convenience fee:</p></div>
                        <div className='right_column_text'><p className='small_text'>{this.props.selected_payment_method ? this.calculateFees() : 'Choose payment method to see fees'}</p></div>
                    </div>

                    
                    <div className='two_column_line'>
                        <div className='left_column_text'><p className='small_text'>Chosen contribution{isMonthly ? ' (per month)' : ''}:</p></div>
                        <div className='right_column_text'><p className='small_text'>${this.props.choose_fee_value}{isMonthly ? `/mo` : ``}</p></div>
                    </div>

                    {isMonthly ? (
                        <div className='monthly_payment_summary margin_top_16'>
                            <div className='two_column_line'>
                                <div className='left_column_text'><p className='small_text bold'>Today&apos;s charge:</p></div>
                                <div className='right_column_text'>
                                    <p className='small_text bold'>${this.calculateTodayChargeTotal().toFixed(2)}</p>
                                </div>
                            </div>
                            <p className='small_text monthly_trust_copy'>
                                You'll be charged today for the first gift, then once per month. You can cancel future gifts at any time. 
                            </p>
                        </div>
                    ) : (
                        <div className='two_column_line'>
                            <div className='left_column_text'><p className='small_text bold'>Total due:</p></div>
                            <div className='right_column_text'><p className='small_text bold'>{'$'+String(Number(this.calculateFees().slice(1)) + Number(this.calculateFinalGift().slice(1)) + Number(this.props.choose_fee_value))}</p></div>
                        </div>
                    )}

                </div>

                <p className='header_for_greeting'>Greeting Preview:</p>
                <div className='greeting_box'>
                    <p>"{this.props.greeting}"</p>
                </div>
                
                <div className='greeting_image_container'>
                    {   this.props.gift_media ?

                        typeof this.props.gift_media === 'string' ? 
                        
                        this.render_gift_media() 
                        
                        :

                        ((this.props.gift_media.type === 'image/jpeg' ||this.props.gift_media.type === 'image/jpg' || this.props.gift_media.type === 'image/png') ? 
                            <img 
                                src={URL.createObjectURL(this.props.gift_media)}
                                className={'greeting_image'}/>
                        :
                            <video className='uploaded_media_preview' controls>
                                <source src={URL.createObjectURL(this.props.gift_media)}/>
                            </video>
                        ) :
                        <img 
                        src={'https://gg-app-images.s3.us-east-2.amazonaws.com/email_pictures/personalized_gift(small).png'}
                        className={'greeting_image no_border'} />
                    }
                </div>
                
        
                
                <MasterButton 
                    buttonText={this.props.buttonText} 
                    handleButtonClick={this.props.handleButtonClick}
                    notSticky={true}
                    
                />

                <div className='disclaimer_checkbox_container'>
                    {this.props.accept_additional_charges ?
                     <i onClick={this.props.toggle} className='material-icons-outlined disclaimer_checkbox'>check_box</i> :
                     <i onClick={this.props.toggle} className='material-icons-outlined disclaimer_checkbox'>check_box_outline_blank</i>}
                    <p className='disclaimer_checkbox_text tiny_text'>I agree to cover the payment processing fees so that {this.props.Gift_for} receives the full gift amount</p>
                </div>

                {this.props.selected_payment_method.type === 'ACH' ? 
                    <div className='disclaimer_checkbox_container'>
                        <i className='material-icons-outlined disclaimer_checkbox'>info</i>
                        <p className='disclaimer_checkbox_text tiny_text'>By confirming, you authorize Greatest Gift Inc. to electronically debit your account and, if necessary, electronically credit your account to correct erroneous debits.</p>
                    </div>
                :null}

                { this.props.guest ?
                <div className='disclaimer_checkbox_container'>
                     <i onClick={this.props.opt_in_out} className='material-icons-outlined disclaimer_checkbox'> {this.props.opt_in ? "check_box" : "check_box_outline_blank" }</i>
                    <p className='disclaimer_checkbox_text tiny_text'>Keep me up to date with Greatest Gift's newsletter</p>
                </div>
                : null }

           </div>
        );
    }
}

export default Gifting_step_4;